// src/pages/BrandManagement/components/BrandPreview.tsx
import React from 'react';
import { Card, CardHeader, CardBody, Button } from 'reactstrap';
import { BrandInfo } from '../types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('brand_management');

interface BrandPreviewProps {
  brandInfo: BrandInfo | null;
}

const BrandPreview: React.FC<BrandPreviewProps> = ({ brandInfo }) => {
  if (!brandInfo) {
    return (
      <Card className="preview-card" style={{ position: 'sticky', top: '24px' }}>
        <CardHeader>
          <h5 className="card-title mb-0">
            <i className="ri-eye-line me-2"></i>{st('xem_truoc_title')}
          </h5>
        </CardHeader>
        <CardBody>
          <div className="text-center py-5 text-muted">
            <i className="ri-image-line" style={{ fontSize: '48px', opacity: 0.3 }}></i>
            <p className="mt-3 mb-0">{st('chua_co_du_lieu_text')}</p>
          </div>
        </CardBody>
      </Card>
    );
  }
  
  const { companyName, companyShortName, logoUrl, primaryColor, secondaryColor } = brandInfo;
  
  return (
    <Card className="preview-card" style={{ position: 'sticky', top: '24px' }}>
      <CardHeader>
        <h5 className="card-title mb-0">
          <i className="ri-eye-line me-2"></i>{st('xem_truoc_title')}
        </h5>
      </CardHeader>
      <CardBody className="p-0">
        {/* Preview Header */}
        <div
          className="preview-header"
          style={{
            padding: '16px 24px',
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
            color: 'white',
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={st('logo_label')}
                  style={{
                    maxHeight: '40px',
                    marginRight: '12px',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    padding: '4px',
                    borderRadius: '4px',
                  }}
                />
              ) : (
                <div
                  style={{
                    width: '120px',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '12px',
                    borderRadius: '4px',
                    fontSize: '12px',
                  }}
                >
                  {st('logo_text')}
                </div>
              )}
              <div>
                <div style={{ fontWeight: 600, fontSize: '16px' }}>
                  {companyName || st('ten_cong_ty_text')}
                </div>
                <div style={{ fontSize: '11px', opacity: 0.8 }}>
                  {companyShortName || 'VTC'}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Preview Content */}
        <div
          className="preview-section"
          style={{
            padding: '24px',
            borderBottom: '1px solid #eff2f7',
          }}
        >
          <h6 className="mb-3">{st('mau_sac_thuong_hieu_title')}</h6>
          <div className="row g-3">
            <div className="col-6">
              <div className="text-center">
                <div
                  style={{
                    width: '100%',
                    height: '60px',
                    backgroundColor: primaryColor,
                    borderRadius: '8px',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 500,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}
                >
                  {st('chu_dao_text')}
                </div>
                <small className="text-muted">{primaryColor}</small>
              </div>
            </div>
            <div className="col-6">
              <div className="text-center">
                <div
                  style={{
                    width: '100%',
                    height: '60px',
                    backgroundColor: secondaryColor,
                    borderRadius: '8px',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 500,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}
                >
                  {st('phu_text')}
                </div>
                <small className="text-muted">{secondaryColor}</small>
              </div>
            </div>
          </div>
        </div>
        
        {/* Preview UI Application */}
        {/* <div
          className="preview-section"
          style={{
            padding: '24px',
            borderBottom: '1px solid #eff2f7',
          }}
        >
          <h6 className="mb-3">Ứng dụng trên UI</h6>
          <div className="d-flex flex-column gap-2">
            <Button
              style={{
                backgroundColor: primaryColor,
                color: 'white',
                border: 'none',
              }}
            >
              <i className="ri-save-line me-1"></i>Primary Button
            </Button>
            <Button
              style={{
                backgroundColor: secondaryColor,
                color: 'white',
                border: 'none',
              }}
            >
              <i className="ri-add-line me-1"></i>Secondary Button
            </Button>
            <div
              style={{
                padding: '12px',
                backgroundColor: '#f8f9fa',
                borderRadius: '6px',
                borderLeft: `3px solid ${primaryColor}`,
              }}
            >
              <small className="text-muted">Accent với màu chủ đạo</small>
            </div>
          </div>
        </div> */}
        
        {/* Preview Footer */}
        <div
          className="preview-footer text-center"
          style={{
            padding: '16px 24px',
            backgroundColor: '#f8f9fa',
          }}
        >
          <small className="text-muted">
            <i className="ri-information-line me-1"></i>
            {st('thay_doi_se_ap_dung_toan_hint')}
          </small>
        </div>
      </CardBody>
    </Card>
  );
};

export default BrandPreview;